import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Autocomplete, TextField } from "@mui/material"
import { useSelector } from "react-redux"

import { LocationDTO } from "../../../DTOs/Production/LocationDTO"
import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto"
import { RootState } from "../../../state/store"

type StoppageLocationCellProps = {
  stoppage: StoppageDto,
  locationOptions: LocationDTO[],
  isLocationOptionsLoading: boolean
  handleLocationChange: (stoppage: StoppageDto, locationId: number) => Promise<void>
}

const StoppageLocationCell: React.FC<StoppageLocationCellProps> = ({
  stoppage,
  locationOptions,
  isLocationOptionsLoading,
  handleLocationChange
}) => {
  const isShiftLocked = useSelector((state: RootState) => state.shift.isLocked);

  return (
    <Autocomplete
      value={locationOptions.find(o => o.id === stoppage.locationId) ?? null}
      classes={{ root: "w-full" }}
      options={locationOptions}
      loading={isLocationOptionsLoading}
      disabled={isLocationOptionsLoading || isShiftLocked}
      getOptionLabel={(o) => o.name}
      onChange={(_, opt) => { handleLocationChange(stoppage, opt?.id ?? 0) }}
      renderInput={params => (
        <TextField
          {...params}
          placeholder="Select Location"
          size="small"
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isLocationOptionsLoading ?
                    <span className="animate-fade-in"><FontAwesomeIcon icon={faSpinner} spin /></span> : null}
                  {params.slotProps.input.endAdornment}
                </>
              )
            }
          }}
        />
      )}
    />
  )
}

export default StoppageLocationCell